import { cbSemanticCssVars, elevationCss } from '@creditornot/cb-ingredients';
import { ModalHeader } from '@creditornot/cbt-modal';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import {
  NullableOrderApiWebhookResponse,
  OrderApiCredentials,
} from 'apis/restaurant-api/merchant-admin/order-api-credentials/types';
import { WoltModal } from 'common/components';

import SetUpOrderApiWebhookForm from './SetUpOrderApiWebhookForm';

type ModalProps = {
  merchantId: string;
  isOpen: boolean;
  onClose: () => void;
  orderApiMetadata: OrderApiCredentials;
  existingWebhook: NullableOrderApiWebhookResponse;
};

const StyledModal = styled(WoltModal)`
  width: 100%;
  max-width: 640px;
`;

const Container = styled.div`
  ${elevationCss(16)}
  background: ${cbSemanticCssVars.surfaceMain};
  border-radius: 8px;
  color: ${cbSemanticCssVars.textPrimary};
`;

const OrderApiWebhookModal = ({ existingWebhook, orderApiMetadata, onClose, isOpen, merchantId }: ModalProps) => {
  return (
    <StyledModal isOpen={isOpen}>
      <Container>
        <ModalHeader onCloseClick={onClose}>
          <FormattedMessage id="merchant-integrations.order-api.webhook.setup" />
        </ModalHeader>

        <SetUpOrderApiWebhookForm
          existingWebhook={existingWebhook}
          credentialId={orderApiMetadata.id}
          merchantId={merchantId}
          onClose={onClose}
          onSubmit={onClose}
        />
      </Container>
    </StyledModal>
  );
};

export default OrderApiWebhookModal;
